/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `public` - 전체 공개
 * `unlisted` - 일부 공개 (링크 공유)
 * `private` - 비공개
 */
export type YoutubePrivacyStatusEnum =
  (typeof YoutubePrivacyStatusEnum)[keyof typeof YoutubePrivacyStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const YoutubePrivacyStatusEnum = {
  public: "public",
  unlisted: "unlisted",
  private: "private",
} as const;
